import * as React from "react";
import Card from "../../../components/DataDisplay/CardComponent";
import i18n from "../../../i18n/i18n";
import { PaymentType } from "../../../models/enums/PaymentType";
import { InvoiceStatusType } from "../../../models/enums/InvoiceStatusType";
import IParentBulkInvoiceVm from "../../../models/home/Payment/IParentBulkInvoiceVm";
import { CertificateType } from "../../../models/flags/CertificateType";
import IssuingAuthorityContactInfoComponent from "./IssuingAuthorityContactInfoComponent";
import AcceptTermsAndConditionsComponent from "./AcceptTermsAndConditionsComponent";
import IErrorVm from "../../../models/home/Error/IErrorVm";

interface IOnlineBulkPaymentForCompanyComponentProps {
  invoice: IParentBulkInvoiceVm;
  validationErrors: IErrorVm[];
  onUpdateAreTermsAndConditionsAccepted: (value: boolean) => void;
}

export default class OnlineBulkPaymentForCompanyComponent extends React.Component<IOnlineBulkPaymentForCompanyComponentProps, any> {
  constructor(props: IOnlineBulkPaymentForCompanyComponentProps) {
    super(props);
  }

  private calculatePriceForParentBulkInvoice(invoice: IParentBulkInvoiceVm) {
    let amount: number = 0.0;

    invoice.childrenInvoices.forEach((childInvoice) => {
      amount = amount += parseFloat(childInvoice.amount.replace(",", "."));
    });

    return amount.toFixed(2).toString().replace(".", ",");
  }

  private generateListOfCildrenInvoiceElement(parentBulkInvoice: IParentBulkInvoiceVm) {
    const listOfElements: JSX.Element[] = [];

    parentBulkInvoice.childrenInvoices.forEach((childInvoice) => {
      listOfElements.push(
        <tr key={childInvoice.application.id}>
          <td>
            {CertificateType.displayName(childInvoice.application.certificateType)} ({childInvoice.application.certificateNumber})
          </td>
          <td>
            {childInvoice.application.citizen.firstName} {childInvoice.application.citizen.lastName}
          </td>
          <td>{childInvoice.amount}</td>
        </tr>
      );
    });

    return listOfElements;
  }

  public render() {
    const { invoice, validationErrors, onUpdateAreTermsAndConditionsAccepted } = this.props;

    const isValid = this.props.validationErrors.length === 0;

    return (
      <div className="confirmation row-fluid">
        <div className="span6">
          <div className="row-fluid">
            <Card title="TEXT_PAYOR">
              <table>
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: "top" }}>{i18n.t("TEXT_CVR")}: </td>
                    <td>
                      <b>{invoice.companyBilled.companyRegistrationIdentifier}</b>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}>{i18n.t("TEXT_COMPANY_NAME")}: </td>
                    <td style={{ wordBreak: "break-word" }}>
                      <b>{invoice.companyBilled.name}</b>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ verticalAlign: "top" }}>{i18n.t("TEXT_COMBINED_ADDRESS")}: </td>
                    <td style={{ wordBreak: "break-word" }}>
                      <b>
                        {!!invoice.companyBilled.address.coName ? (
                          <span>
                            {invoice.companyBilled.address.coName}
                            <br />
                          </span>
                        ) : (
                          ""
                        )}
                        {invoice.companyBilled.address.combinedStreetAddressLine}
                        <br />
                        {invoice.companyBilled.address.postalCode}&nbsp;
                        {invoice.companyBilled.address.postalDistrict}&nbsp;
                        <br />
                        {invoice.companyBilled.address.countryName}
                      </b>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h2>{i18n.t("TEXT_CERTIFICATES")}</h2>
              <div className="table table-responsive">
                <table className="table table-bordered row-fluid">
                  <thead>
                    <tr>
                      <th style={{ background: "white" }}>{i18n.t("TEXT_LICENSE_TYPE")}</th>
                      <th style={{ background: "white" }}>{i18n.t("TEXT_APPLICANT")}</th>
                      <th style={{ background: "white" }}>{i18n.t("TEXT_INVOICE_PRICE")}</th>
                    </tr>
                  </thead>
                  <tbody>{this.generateListOfCildrenInvoiceElement(invoice)}</tbody>
                  <tbody>
                    <tr>
                      <th colSpan={2} style={{ background: "white" }}></th>
                      <th style={{ background: "white" }}>{this.calculatePriceForParentBulkInvoice(invoice)}</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>
          </div>
        </div>
        <div className="span6">
          <Card title="TEXT_CERTIFICATE">
            <table>
              <tbody>
                <tr>
                  <td>{i18n.t("TEXT_INVOICE_NUMBER")}: </td>
                  <td style={{ wordBreak: "break-word" }}>
                    <b>{invoice.number}</b>
                  </td>
                </tr>
                <tr>
                  <td>{i18n.t("TEXT_INVOICE_PRICE")}: </td>
                  <td style={{ wordBreak: "break-word" }}>
                    <b>{this.calculatePriceForParentBulkInvoice(invoice)} DKK</b>
                  </td>
                </tr>
                <tr>
                  <td>{i18n.t("TEXT_INVOICE_PAYMENT_TYPE")}: </td>
                  <td style={{ wordBreak: "break-word" }}>
                    <b>{PaymentType.displayName(invoice.paymentType)}</b>
                  </td>
                </tr>
                <tr>
                  <td>{i18n.t("TEXT_INVOICE_TRANSACTION_STATUS")}: </td>
                  <td style={{ wordBreak: "break-word" }}>
                    <b>{InvoiceStatusType.displayName(invoice.status)}</b>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
            <div className="row-fluid">
              <table>
                <AcceptTermsAndConditionsComponent areTermsAndConditionsAccepted={invoice.areTermsAndConditionsAccepted} validationErrors={validationErrors} onUpdateAreTermsAndConditionsAccepted={(value) => onUpdateAreTermsAndConditionsAccepted(value)} />
                <tbody>
                  <tr>
                    <td colSpan={2}>
                      <form action={process.env.DIBS_URL_FOR_BULK_PAYMENT} method="post">
                        <input name="Id" type="hidden" value={invoice.id} />
                        <input name="AreTermsAndConditionsAccepted" type="hidden" value={invoice.areTermsAndConditionsAccepted.toString()} />
                        <input name="IsInvoicePending" type="hidden" value={invoice.isInvoicePending.toString()} />
                        {
                          <button disabled={!isValid} type="submit" className="btn btn-oim pull-right" data-ui-test="btn-pay">
                            {i18n.t("TEXT_PAY")} <span className="accessibility"></span> <i className="icon-chevron-right"></i>
                          </button>
                        }
                      </form>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr />
            <IssuingAuthorityContactInfoComponent certificateType={invoice.childrenInvoices.find((x) => x !== undefined)?.application?.certificateType} />
          </Card>
        </div>
      </div>
    );
  }
}
